import type { Board_PermissionLevel } from '@trello/model-types';
import { getMilliseconds } from '@trello/time';

// eslint-disable-next-line @trello/no-module-logic
export const PRELOAD_PHOTO_EXPIRATION = getMilliseconds({ hours: 1 });
// eslint-disable-next-line @trello/no-module-logic
export const PRELOAD_PERMISSION_EXPIRATION = getMilliseconds({ minutes: 1 });
export const PERSONAL_VIS_OPTIONS: Board_PermissionLevel[] = [
  'private',
  'public',
];
export const ORG_VIS_OPTIONS: Board_PermissionLevel[] = [
  'private',
  'org',
  'public',
];
export const ENTERPRISE_VIS_OPTIONS: Board_PermissionLevel[] = [
  'private',
  'org',
  'enterprise',
  'public',
];
